window.options.slickOptions.slidesToScroll = 4;
window.options.datepicker.dayViewHeaderFormat = 'MMMM YYYY';
